/*
* Created on Jan 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React from 'react';
import useToggle from "../../hook/ToggleHook";
import {useOrganization, useOrganizationListRefresh} from "../../context/OrganizationContext";
import { useNavigate } from "react-router-dom"
import {useTranslation} from "react-i18next";
import {useQuery} from "@tanstack/react-query";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";

const HeaderOrgSelectorComponent = ({refresh}) => {
    const {OrganizationAPI} = useOrganizationApi();
    const {t} = useTranslation();
    const [open, node] = useToggle();
    const {getCurrentOrg, setCurrentOrg} = useOrganization();
    const org = getCurrentOrg();
    const history = useNavigate();
    const {refresh:orgListRefresh} = useOrganizationListRefresh();

    // { status, data, isError, isFetching, error } useQuery variables
    const { data:organizations} = useQuery({
        queryKey: ["get_org_list", refresh, orgListRefresh],
        queryFn: async () => {
            try {
                const org_list = await OrganizationAPI.get('organization', {limit: 100, slim: true});
                return org_list.result;
            } catch (e) {
                throw e;
            }
        }
    });

    const click = (org) => {
        setCurrentOrg(org);
        if (org == null) {
            history('/');
        }
        else {
            const currentPath = window.location.pathname.split('/')[2] || 'settings';
            history(`/${org.organization_id}/${currentPath}`);
        }
    }

    return (
        <div className={`comp-select org-select drop-adjustable ${open==='show' ? 'active' : ''}`} ref={node}>
            <div className="select-toggle">
                <span className="select-label">{(org && org.name) || t('@My Organization@') }</span>
            </div>

            <div className={"comp-dropdown " + open}>
                <ul className="comp-dropdown-menu add-scroll overlay-scroll">
                    <li className="section my-org">
                        <div className="section-items selection" onClick={() => {
                            click(null)
                        }}>{t('@My Organization@')}</div>
                    </li>
                    <li className="section-divide"></li>
                    {organizations && organizations.map((org) => {
                        return (
                            <li className="section" key={org.organization_id}>
                                <div className="section-items selection" onClick={() => {
                                    click(org)
                                }}>{org.name}</div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default HeaderOrgSelectorComponent;